import { useFetchOnboardingQuery } from 'store/apis';
import { selectCurrentUserInfo } from 'store/slices';
import { useAppSelector } from 'store/store.hook';
import { resolveOnboardingStatus } from './onboarding-status';

export const useOnboarding = () => {
  const { orgSlug, canCreateBuildings } = useAppSelector(selectCurrentUserInfo);

  const { data = {}, isError, ...rest } = useFetchOnboardingQuery({ orgSlug });

  const {
    status = null,
    building_id: buildingId = null,
    zone_id: zoneId = null,
    employee_id: employeeId = null,
  } = data;

  const onboarding = {
    status: resolveOnboardingStatus(status, isError, canCreateBuildings),
    buildingId,
    zoneId,
    employeeId,
  };

  return { data: onboarding, isError, ...rest };
};
